import { useEffect, useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { CheckCircle2, Loader2 } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("polling");
  const [details, setDetails] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        setDetails(data);
        if (data.payment_status === "paid") { setStatus("paid"); return; }
        if (data.status === "expired" || data.status === "failed") { setStatus("failed"); return; }
        if (tries++ < 15) setTimeout(poll, 2000);
        else setStatus("pending");
      } catch { setStatus("error"); }
    };
    poll();
  }, [sessionId]);

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <div className="max-w-2xl mx-auto px-6 py-20 text-center">
        {status === "polling" && (
          <>
            <Loader2 className="w-10 h-10 mx-auto animate-spin text-primary mb-6" />
            <h1 className="font-heading text-3xl md:text-4xl font-bold tracking-tight mb-3">Confirmando pago…</h1>
            <p className="text-muted-foreground">Estamos verificando tu pago con Stripe.</p>
          </>
        )}
        {status === "paid" && (
          <>
            <CheckCircle2 className="w-14 h-14 mx-auto text-emerald-500 mb-6" />
            <h1 className="font-heading text-4xl md:text-5xl font-bold tracking-tight mb-3">¡Pago confirmado!</h1>
            <p className="text-muted-foreground mb-2">Se pagaron ${details?.amount?.toFixed(0)} y la propuesta fue aceptada.</p>
            <p className="text-muted-foreground mb-8">El proyecto ahora está en curso.</p>
            <Link to="/dashboard">
              <Button className="rounded-full h-11 px-8" data-testid="go-to-dashboard-btn">Ir al Dashboard</Button>
            </Link>
          </>
        )}
        {(status === "failed" || status === "error" || status === "pending") && (
          <>
            <h1 className="font-heading text-3xl md:text-4xl font-bold tracking-tight mb-3">Estado del pago</h1>
            <p className="text-muted-foreground mb-8">
              {status === "pending" ? "Aún procesando. Puedes revisar más tarde." : "No pudimos confirmar el pago."}
            </p>
            <Button onClick={() => navigate("/dashboard")} className="rounded-full">Volver al Dashboard</Button>
          </>
        )}
      </div>
    </div>
  );
}
